export default {
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
  apiUri: 'https://capi.cmsriver.com/api/v1/',
  socketUri: 'https://chat.cmsriver.com',
  // apiUri: 'http://localhost:5002/api/v1/',
  // socketUri: 'http://localhost:5001',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  encrypt(msg: string) {
    // TODO encrypt message here
    return msg;
  },
  appUri: 'https://nutrilite.co.id/youthfuelsummerfest/',
};
